"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.createSearchEntry = void 0;
var _utils = require("../utils");
var _entityLite = require("./entity-lite");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/**
 * Creates a entry to be indexed by Algolia.
 *
 * The intention here is to define a common interface that content
 * which should be searchable comforms to. This allows us to use only
 * one factory to transform content rather than have specialised factories
 * for every content type.
 *
 * @param {object} entry
 * @param {object} entry.sys
 * @param {string} entry.sys.id
 * @param {object} entry.sys.contentType
 * @param {object} entry.sys.contentType.sys
 * @param {string} entry.sys.contentType.sys.id
 * @param {object} entry.fields
 * @param {string} entry.fields.title - The title of the entry
 * @param {string} entry.fields.slug - The slug for the entry
 * @param {object} [entry.fields.category] - The category the entry belongs to
 * @param {object} [entry.fields.category.fields] - The category fields
 * @param {string} [entry.fields.category.fields.slug] - The category slug
 * @param {string} [entry.fields.category.fields.title] - The category title
 * @param {object} [entry.fields.subCategory] - The subcategory the entry belongs to
 * @param {object} [entry.fields.subCategory.fields] - The subcategory fields
 * @param {string} [entry.fields.subCategory.fields.slug] - The subcategory slug
 * @param {string} [entry.fields.subCategory.fields.title] - The subcategory title
 * @param {object} [entry.fields.seo] - An SEO content model
 * @param {object} [entry.fields.seo.fields] - Fields for the SEO content model
 * @param {array<string>} [entry.fields.seo.field.keywords] - SEO keywords for this entry
 * @returns {object}
 */

var createSearchEntry = function createSearchEntry(_ref) {
  var _sys$contentType;
  var sys = _ref.sys,
    fields = _ref.fields;
  var indexNameMap = {
    category: 'products',
    productPage: 'products',
    helpPost: 'help'
  };
  var parent = (0, _utils.getProp)(fields, 'parent') || (0, _utils.getProp)(fields, 'category');
  var subLevel = (0, _utils.getProp)(fields, 'subLevel') || (0, _utils.getProp)(fields, 'subCategory');
  var pageType = (0, _utils.getProp)(fields, 'pageType');
  var contentType = (0, _utils.getProp)(sys === null || sys === void 0 ? void 0 : (_sys$contentType = sys.contentType) === null || _sys$contentType === void 0 ? void 0 : _sys$contentType.sys, 'id');
  var indexName = indexNameMap[pageType || contentType] || null;
  return _objectSpread(_objectSpread({}, (0, _entityLite.createEntityLite)({
    sys: sys,
    fields: fields
  })), {}, {
    indexName: indexName,
    objectID: (0, _utils.getProp)(sys, 'id'),
    name: (0, _utils.getProp)(fields, 'name') || (0, _utils.getProp)(fields, 'title'),
    slug: (0, _utils.getProp)(fields, 'slug'),
    title: (0, _utils.getProp)(fields, 'title'),
    description: (0, _utils.getProp)(fields, 'shortDescription'),
    parent: parent ? createSearchEntry(parent) : null,
    subLevel: subLevel ? createSearchEntry(subLevel) : null,
    keywords: (0, _utils.getProp)(fields, 'searchKeywords') || []
  });
};
exports.createSearchEntry = createSearchEntry;
var searchEntryFactory = function searchEntryFactory(items) {
  return createSearchEntry(items.shift());
};
var _default = searchEntryFactory;
exports["default"] = _default;